import React, { Component } from 'react'
import './ValueAddedServices.css'
// let valueaddedservices=['Details not available']
class ValueAddedServices extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            valueaddedservices:['Details not available']
        }
    }
    
    // componentWillReceiveProps(nextProps){
    //     valueaddedservices=nextProps.transporter_data.value_added_services;
    //     if(valueaddedservices==undefined || valueaddedservices==null){
    //         valueaddedservices=['Details not available']
    //     }
    // }
    
    static getDerivedStateFromProps(nextProps, prevState){
        // valueaddedservices=nextProps.transporter_data.value_added_services;
        //     if(valueaddedservices==undefined || valueaddedservices==null){
        //         valueaddedservices=['Details not available']
        //     }
        if(nextProps.transporter_data.value_added_services===undefined ||nextProps.transporter_data.value_added_services===null){
            return{
                valueaddedservices:['Details not available']
            }
        }
        else{
            return{
                valueaddedservices:nextProps.transporter_data.value_added_services
            }
        }
    }

    render() {
        let p = this.state.valueaddedservices.map((item,index) => {
            return <div key={index} className="vas"><span>{item}</span></div>
        })
        return (
            <>
                <div className="valueaddedservicescard">
                    <div className="valueaddedservicescontainer row">
                        <div className="col-12">
                            <h3 className="data_header">Value Added Services</h3>
                        </div>
                        <div className="col-12">
                            {(p.length!==0)?(p):('Details not available')}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default ValueAddedServices
